// import Home from '../pages/Home';
import Home from '../pages/HomeStripe';
import HomePublic from '../pages/HomeStripePublic';
import SuccessPage from '../pages/Success';

export default [
  {
    path: '/reactivation',
    element: Home,
    exact: false,
    isPrivate: true,
  },
  {
    path: '/reactivate',
    element: HomePublic,
    exact: false,
    isPrivate: false,
  },
  {
    path: '/success',
    element: SuccessPage,
    exact: false,
    isPrivate: true,
  },
];
